import { Link } from '@inertiajs/react'

interface Props {
  plan?: string
}

export default function BorrowerUpgradeBanner({ plan = 'free' }: Props) {
  const targetPlan = plan === 'free' ? 'Pro' : 'Portfolio'
  const price = plan === 'free' ? '$19/mo' : '$39/mo'

  return (
    <div
      className="rounded-xl p-5 mt-6"
      style={{ background: 'linear-gradient(135deg, var(--color-dl-chrome-from) 0%, var(--color-dl-chrome-to) 100%)' }}
    >
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <p className="text-sm font-bold text-white">
            Unlock {targetPlan} features
          </p>
          <p className="text-xs text-dl-muted mt-1">
            {plan === 'free'
              ? 'Get true cost analysis, AI exit strategies, and portfolio health reports.'
              : 'Get property grouping, 50 loans, and advanced portfolio management.'}
          </p>
        </div>
        <Link
          href="/my-loans/billing"
          className="shrink-0 px-4 py-2 rounded-lg text-sm font-semibold bg-dl-accent text-gray-900 hover:bg-dl-accent-hover transition-colors"
        >
          Upgrade to {targetPlan} &middot; {price}
        </Link>
      </div>
    </div>
  )
}
